import { useContent } from "../context/ContentContext";
import { Instagram, Youtube, Music2, MessageCircle } from "lucide-react";

export const SocialLinks = ({ variant = "light", testId = "social-links" }) => {
  const { content } = useContent();
  const active = [
    { id: "instagram", label: "Instagram", link: content.socials?.instagram, Icon: Instagram },
    { id: "tiktok", label: "TikTok", link: content.socials?.tiktok, Icon: Music2 },
    { id: "youtube", label: "YouTube", link: content.socials?.youtube, Icon: Youtube },
    { id: "whatsapp", label: "WhatsApp", link: content.contact?.whatsapp, Icon: MessageCircle },
  ].filter((s) => s.link);
  if (active.length === 0) return null;

  const styles =
    variant === "dark"
      ? "border-[#C0C7D1]/50 text-[#C0C7D1] hover:text-white hover:border-white"
      : "border-[#C0C7D1] text-[#C0C7D1] hover:text-[#0057FF] hover:border-[#0057FF]";

  return (
    <div data-testid={testId} className="flex items-center justify-center gap-4 flex-wrap">
      {active.map(({ id, label, link, Icon }) => (
        <a
          key={id}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          data-testid={`${testId}-${id}`}
          className={`w-11 h-11 rounded-full border flex items-center justify-center transition-colors duration-200 ${styles}`}
        >
          <Icon size={19} />
        </a>
      ))}
    </div>
  );
};
